"use client";

import { useEffect } from "react";
import { useScrollRestorer } from "next-scroll-restorer";

const ClientSideScrollRestorer = () => {
  useScrollRestorer();

  // On back/forward, if URL has a hash, strip it to avoid anchor auto-scroll overriding restoration
  useEffect(() => {
    const onPopState = () => {
      if (window.location.hash) {
        try {
          const { state } = window.history;
          const urlWithoutHash =
            window.location.pathname + window.location.search;
          window.history.replaceState(state, "", urlWithoutHash);
        } catch {}
      }
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  return <></>;
};

export default ClientSideScrollRestorer;
